// For side effects
import "common/src/browser_logs"
